/**
 * Created by sven.bluege on 04.04.2017.
 */
window.Eventgallery = window.Eventgallery || {};


require('./backend/vue/uploader/index.js');
require('./backend/vue/filesync/index.js');
require('./backend/vue/thumbnailcreator/index.js');
require('./backend/vue/cacheclear/index.js');
require('./backend/vue/imagecontentpluginform/index.js');
require('./backend/vue/scalepriceeditor/index.js');


require('./backend/js/EventgalleryBehavior.js');
require('./backend/js/EventgalleryInlineFormEdit.js');
require('./backend/js/EventgalleryGooglePhotos.js');
require('./backend/js/EventgalleryFlickr.js');
require('./backend/js/Albumselector.js');
require('./backend/js/LocalizableText.js');

require('./backend/css/eventgallery.css');
require('./frontend/less/fontawesome.less');

require('./frontend/js/photoswipe/PhotoSwipeGallery.js');
require('./frontend/js/photoswipe/PhotoSwipeGallerySlide.js');


